import styled from '@emotion/styled';

export const Description = styled.div`
    font-family: ${({ theme }): string => theme.font.family};
    font-size: ${({ theme }): string => theme.font.size.normal};
    color: ${({ theme }): string => theme.color.black200};
    margin-bottom: 20px;
`;
